import React from 'react'
import { Link } from 'react-router-dom'
import abuso_sustancias from '../assets/images/psicologo/abuso_sustancias.jpg'
import Navbar from '../components/navbar'
import Shape from '../components/shape'
import ShapeTwo from '../components/shape-two'
import Footer from '../components/footer'
import fondo from '../assets/images/Brochure_Neuroelectrics/7.png'
import bg1 from '../assets/images/bg.jpg'
import bg2 from '../assets/images/Brochure_Deymed_Duomag/3.png'

export default function PageTerm() {
  return (
    <>
     <Navbar/>
     
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg2})`, backgroundPosition:'center'}}>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title text-white">Estimulación Magnética Transcraneal repetitiva (EMTr)</h4>
                          <p className="text-muted mb-0">Características, aplicaciones y procedimientos</p>                                            
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="fw-bold text-white">Inicio</Link></li>
                          <li className="list-inline-item"><Link to="#" className="fw-bold text-white">Servicios</Link></li>
                          <li className="list-inline-item">
                              <span className="text-primary fw-bold">EMTr</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>
<section className="section">
  <div className="container">
    <div className="row justify-content-center" style={{textAlign:'justify', padding:20}}>
      <div className="col-12">
        <h4>Introducción</h4>
        <p className="text-muted">
          La Estimulación Magnética Transcraneal repetitiva (EMTr), también conocida por sus siglas en inglés como rTMS (repetitive Transcranial Magnetic Stimulation), es un procedimiento médico no invasivo que utiliza campos magnéticos para estimular las células nerviosas en el cerebro.
        </p>
        <br />
        <h4 className='text-warning'>Características principales</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          No invasiva: No requiere cirugía ni sedación.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Mecanismo de acción: Se coloca una bobina electromagnética sobre el cuero cabelludo, la cual genera pulsos magnéticos que atraviesan el cráneo sin atenuarse. Estos pulsos crean corrientes eléctricas muy pequeñas en las áreas del cerebro que se encuentran debajo de la bobina, lo que estimula la actividad neuronal.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Efecto terapéutico: El objetivo es modular la actividad de circuitos cerebrales específicos que se cree que están implicados en diferentes trastornos neuropsiquiátricos. La frecuencia de los pulsos puede ser alta (estimulante) o baja (inhibidora), dependiendo del efecto deseado.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Aplicaciones principales: Se utiliza principalmente en el tratamiento de la depresión mayor resistente a otros tratamientos, pero también se investiga y usa en el tratamiento de la ansiedad, el trastorno obsesivo-compulsivo (TOC), el dolor crónico y otros trastornos neurológicos.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Procedimiento: Las sesiones suelen durar entre 20 y 40 minutos. Generalmente, se realizan de 4 a 5 veces por semana durante varias semanas.
        </p>
        <br />
        <h4>Conclusión</h4>
        <p className="text-muted">
          La rTMS es una técnica segura y eficaz para modular la actividad cerebral y ofrecer una alternativa terapéutica para pacientes que no han respondido a los tratamientos convencionales.
        </p>
      </div>
    </div>
  </div>
</section>
    <Footer/>
    </>
  )
}
